import { Document, FixMe } from '@greenkub-fronts/shared/interface';

import styles from './pdf-body-landing-page.module.scss';

import HeaderFooterLandingPageFeature from '../../../feature/header-footer-landing-page-feature/header-footer-landing-page-feature';

export interface PdfBodyLandingPageProps {
  documentObjectURL: string;
  setIsDocumentLoaded: (value: boolean) => void;
  document: Document | null;
  sign1Ref: FixMe;
}

const PdfBodyLandingPage = (props: PdfBodyLandingPageProps) => {
  const { documentObjectURL, setIsDocumentLoaded, document, sign1Ref } = props;

  return (
    <div className={styles['LandingPage-container']}>
      <HeaderFooterLandingPageFeature sign1Ref={sign1Ref} />
      {documentObjectURL !== null ? (
        document?.mimeType.startsWith('image/') ? (
          <div>
            <img
              src={documentObjectURL}
              alt=""
              onLoad={() => setIsDocumentLoaded(true)}
            />
          </div>
        ) : (
          <div
            style={{ position: 'relative', height: '0', padding: '100% 0 0 0' }}
          >
            <iframe
              title="pdf viewer"
              src={documentObjectURL}
              style={{
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
              }}
              onLoad={() => setIsDocumentLoaded(true)}
            />
          </div>
        )
      ) : (
        <></>
      )}
      {/*</Loader>*/}
    </div>
  );
};

export default PdfBodyLandingPage;
